/*
 * Filename: template-selection-panel.component.tsx
 * Description: Landing page for template configuration.
 */

import React, { Component, ReactNode, BaseSyntheticEvent } from 'react';
import { observer } from 'mobx-react';
import GridTemplateConfigurationController from './grid-template-config.controller';
import { CQAppStore } from '../../../store/cq-app-store';
import { Field, ErrorMessage } from 'formik';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { TemplateSFObjectStore } from '../../../store/models/template-object.model';
import { Utility } from '../../../common/utility';
import { CQAppConstant } from '../../../app-constants';


class CQGridTemplateSelectionPanelClass extends Component<{ handleChange: Function, templateName: string, isLayoutApplicable: boolean, errors: any, touched: any }, {
    selectedObjectName: string,
    selectedLayoutName: any, isObjectSelectionDisabled: boolean, isObjectDropDowndisabled : boolean,
    isChildDropDownDisabled: boolean,
}> {
    private readonly templateConfigCtrl: GridTemplateConfigurationController;
    private readonly util: Utility;
    constructor(props: Readonly<{ handleChange: Function, templateName: string, isLayoutApplicable: boolean, errors: any, touched: any }>) {
        super(props);
        this.templateConfigCtrl = new GridTemplateConfigurationController();
        this.util = new Utility();
        this.state = {
            selectedObjectName: '',
            isObjectDropDowndisabled : false,
            isChildDropDownDisabled: false,
            selectedLayoutName: '',
            isObjectSelectionDisabled: false
        };
    }

    async componentDidMount() {
        CQAppStore.loader.setVisibility(true);
        const OutputConfig = CQMasterDataStore.OutputConfig;
        const templateObj = OutputConfig.getStoreData(this.props.templateName);
        if(templateObj.componentName !== '' && templateObj.hasOwnProperty('ruleElements') && Object.keys(templateObj.ruleElements).length > 0){
            CQAppStore.loader.setVisibility(true);
            this.templateConfigCtrl.getObjects();
            await this.templateConfigCtrl.getObjectFields(templateObj.objectApiName, true);
            await this.templateConfigCtrl.getAllObjectFields(templateObj.objectApiName, true, true);
            const parentObjectValue:any = TemplateSFObjectStore.objectFields.fields.filter((objField:any) => {
                return objField.referenceTo[0] === templateObj.parentObjectApiName || objField.name === templateObj.parentObjectApiName;
            });
            this.templateConfigCtrl.getMainReferenceObjectFields(parentObjectValue[0].referenceTo[0], false,false);
            this.setState({
                selectedObjectName: templateObj.objectApiName,
                selectedLayoutName: JSON.stringify(parentObjectValue[0]),
                isObjectSelectionDisabled : true,
                isChildDropDownDisabled: true,
            }, () =>  CQAppStore.loader.setVisibility(false));
        } else {
            this.templateConfigCtrl.getObjects();
        }
        
    }


    public render(): ReactNode {
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height scroll-content slds-p-around_small">
                        <div className="slds-grid slds-grid_vertical">
                            <>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">Child Object</label>
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select className="slds-select" id="select-01" onChange={this.onObjectChanged} disabled={this.state.isObjectSelectionDisabled} value={this.state.selectedObjectName}>
                                                <option value="">Please select</option>
                                                {TemplateSFObjectStore.sfObjects.map((sfObject) => {
                                                    return (<option key={sfObject.name} value={sfObject.name}>{sfObject.label}</option>);
                                                })};
                                                 </select>
                                        </div>
                                    </div>
                                    <ErrorMessage component="span" className="slds-text-color_destructive" name="selectObject" />
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-02">Parent Object</label>
                                    <div className="slds-form-element__control">
                                        <div className="slds-select_container">
                                            <select className="slds-select" disabled={this.state.isChildDropDownDisabled} id="select-02" onChange={(e) => this.onParentObjectChange(e)} value={this.state.selectedLayoutName}>
                                                <option value="">Please select</option>
                                                {TemplateSFObjectStore.objectFields.fields.map((fieldValue: any) => {
                                                    
                                                    if (fieldValue.custom) {
                                                        return (<option key={fieldValue.name + fieldValue.label} value={JSON.stringify(fieldValue)}>{fieldValue.label} ( {fieldValue.name} )</option>);
                                                    }
                                                })};
                                                    </select>
                                            {this.props.errors.selectLayout &&
                                                this.props.touched.selectLayout &&
                                                <div className="input-feedback">
                                                    {this.props.errors.selectLayout}
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    /**
    * @private
    * @memberof CQGridTemplateSelectionPanelClass
    */
    private onObjectChanged = async (e: BaseSyntheticEvent) => {
        const { selectedObject, prefixName } = CQMasterDataStore.OutputConfig.getStoreData(this.props.templateName);
        
        //sets the value of prefix when loaded from org
        if (selectedObject) {
            this.templateConfigCtrl.setPrefixName(this.props.templateName, false, prefixName);
        }
        if (e.target.value !== '') {
            CQMasterDataStore.OutputConfig.reset();
            CQMasterDataStore.GridObject.reset();
            CQMasterDataStore.RuleElements.reset();
            const value = e.target.value;
            const childObject = TemplateSFObjectStore.sfObjects.filter((sfObject: any) => {
                return sfObject.name === value;
            });
            let childObjectApiName:string = (childObject.length && childObject[0].name)  as string;
            let compName = '';
            if (childObjectApiName && childObjectApiName.includes('__c')) {
                childObjectApiName = childObjectApiName.replace('__c', '');
            }
            childObjectApiName = this.util.toPascalCase(childObjectApiName);
            compName = `cqui${childObjectApiName}Grid`;

            this.templateConfigCtrl.updateFieldValue('componentName', compName, this.props.templateName);
            this.templateConfigCtrl.setPrefixName(this.props.templateName, true);
            this.setState({ selectedObjectName: value });
            await this.templateConfigCtrl.getObjectFields(value, true);
            await this.templateConfigCtrl.getAllObjectFields(value, true, true);
            // this.templateConfigCtrl.setSelectedObject(this.props.templateName, value);
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.templateName, 'objectApiName', value);
        }
    }

    /**
     * @private
     * @memberof CQGridTemplateSelectionPanelClass
     */
    private onParentObjectChange = (e: BaseSyntheticEvent) => {
        if (e.target.value !== '') {
            this.setState({
                selectedLayoutName: e.target.value
            });
            const parentObjectValue = JSON.parse(e.target.value);
            this.templateConfigCtrl.getMainReferenceObjectFields(parentObjectValue.referenceTo[0], false,false);
            let parentObjectApiName = parentObjectValue.referenceTo[0] || parentObjectValue.name;
            let relationalField = parentObjectValue.name;
            this.templateConfigCtrl.updateFieldValue('parentObjectApiName', parentObjectApiName, this.props.templateName);
            this.templateConfigCtrl.updateFieldValue('relationalField', relationalField, this.props.templateName);
        }
    }
}

export const CQGridTemplateSelectionPanel = observer(CQGridTemplateSelectionPanelClass);
